export default __webpack_public_path__ + "static/media/background_light.b3ab5345.jpg";